import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Badge } from "../ui/badge";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import tests from "@/shared/api/tests";
import { cn } from "@/lib/utils";
import { format, set } from "date-fns";

export function TestCard({ title, type, description, link, card, user }) {
  const [completed, setCompleted] = useState(false);
  const [results, setResults] = useState(null);
  const [selected, setSelected] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const id = e.target.value;
    setSelected(id);
    if (id) navigate(`/tests/results/${id}`);
  };

  const fetchStatus = async () => {
    try {
      const status = await tests.getTestStatus(type);
      const results = await tests.getTestResultsByType(type);
      setCompleted(status.data.status);
      setResults(results.data);
    } catch (err) {
      console.error(err.message);
    }
  }

  const fetchStatusByUser = async () => {
    try {
      const status = await tests.getTestStatusByUser(user, type);
      const results = await tests.getTestResultsByUser(user, type);
      setCompleted(status.data.status);
      setResults(results.data);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    if (user) {
      fetchStatusByUser();
    } else {
      fetchStatus();
    }
  }, [type]);

  return (
    <Card className={cn("hover:shadow-md bg-white/5 backdrop-blur-sm border border-white/20 transition-shadow w-full", card ? 'flex flex-col justify-between' : '')}>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <CardTitle className="font-serif flex items-center gap-2">
              {title}
              {completed && <CheckCircle2 className="w-5 h-5 text-primary" />}
            </CardTitle>
            <CardDescription className="mt-2">{description}</CardDescription>
          </div>
          {!card ? completed ? (
            <Badge variant="default" className="bg-primary">
              Пройден
            </Badge>
          ) : <Badge variant="outline">Не пройден</Badge> : null}
        </div>
      </CardHeader>
      <CardContent className="flex w-full justify-between items-end">
        {completed && !card ? (
          <div className="flex flex-col">
            <label
              htmlFor="results"
              className="text-sm text-muted-foreground"
            >
              Результаты:
            </label>
            <select
              id="results"
              value={selected}
              className="w-full rounded-lg border bg-white border-foreground p-2 max-w-xs h-[36px]"
              onChange={handleChange}
            >
              <option value="" disabled>Выберите результат</option>
              {results?.map((result) => (
                <option key={result._id} value={result._id}>
                  {format(
                    set(new Date(result.createdAt), {
                      hour: 12,
                      minute: 0,
                      second: 0,
                    }),
                    "dd.MM.yyyy HH:mm"
                  )}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div />
        )}

        {!user && (
          <Link to={link} className="flex items-center justify-end">
            <Button className="bg-white text-olive-800 duration-300 hover:scale-105 border border-olive-200 rounded-2xl hover:bg-olive-100"
            >Пройти тест</Button>
          </Link>
        )}

      </CardContent>
    </Card>
  );
}
